import React from 'react';

export function Portugal(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H190V342H0V0Z" fill="#006600"/>
      <path d="M190 0H513V342H190V0Z" fill="#FF0000"/>
      <circle cx="190" cy="171" r="55" fill="#FFD700" stroke="#003399" strokeWidth="5"/>
      <circle cx="190" cy="171" r="38" fill="white" stroke="#003399" strokeWidth="3"/>
      <path d="M167,150 L167,192 L213,192 L213,150Z" fill="#003399"/>
      <path d="M167,150 L190,130 L213,150Z" fill="#003399"/>
    </svg>
  );
}
